import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
// import { AudienceData } from '../audience/models/audience-data-table.model';
// import { IAllInterests } from '../optimise/labs-page/labs-recommendations/labs-recommendations.interface';
// import { IDexterAction } from '../optimise/models/new-recommendation.interface';
import { SourceChannel } from '../sidenav/sidenav/sidenav-channel-buttons.enum';
import { SourcePlatform } from '../sidenav/sidenav/sidenav-platform-menu';

@Injectable({
	providedIn: 'root'
})
export class AccountTypeService {
	private _accountType = new ReplaySubject<SourceChannel>(1);
	private _accountPlatform = new ReplaySubject<SourcePlatform>(1);

	public readonly accountType: Observable<SourceChannel> = this._accountType.asObservable();
	public readonly accountPlatform: Observable<SourcePlatform> = this._accountPlatform.asObservable();
	public readonly localStorageChannelKey = 'source_channel';
	public readonly localStoragePlatformKey = 'source_platform';

	public selectedLabsCampaign$: BehaviorSubject<string> = new BehaviorSubject('Select adset or campaign');
	public reloadDexterHealth$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	public reloadSync$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	public selectedCreatorAdset$: BehaviorSubject<string> = new BehaviorSubject('Select adset');
	public selectedSyncCampaign$: BehaviorSubject<string> = new BehaviorSubject('Select campaign');
	public optimizationScore$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	public setAccountType(sourceChannel: SourceChannel): void {
		this._accountType.next(sourceChannel);
		localStorage.setItem(this.localStorageChannelKey, sourceChannel + '');
	}

	public getAccountTypeObservable(): Observable<SourceChannel> {
		return this.accountType;
	}

	public setAccountPlatform(sourcePlatform: SourcePlatform): void {
		this._accountPlatform.next(sourcePlatform);
		localStorage.setItem(this.localStoragePlatformKey, sourcePlatform + '');
	}

	public getAccountPlatformObservable(): Observable<SourcePlatform> {
		return this.accountPlatform;
	}
}
